import script from "./TrendChart.vue?vue&type=script&setup=true&lang=js"
export * from "./TrendChart.vue?vue&type=script&setup=true&lang=js"

import "./TrendChart.vue?vue&type=style&index=0&id=51f5e828&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51f5e828"]])

export default __exports__